import axios from 'axios'
// 引入vuex
import store from '../store'
// 引入element-plus
import {
    ElMessage,
    ElMessageBox
} from 'element-plus'
// 引入logout方法
import {
    logOut
} from '../network/login'
// 常量
import {
    grant_type,
    client_id,
    client_secret
} from '../common/const.js'
// axios设置
axios.defaults.timeout = 600000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
axios.defaults.withCredentials = true; // 前端跨域传递cookie设置
// axios.defaults.responseType = 'blob'  
//   development本地
//   production 生成环境
//   test 测试环境 
console.log(process.env.NODE_ENV)

// 请求实例1：不需要token调用此实例
export function requestPublic(config) {
    const instance = axios.create({})
    instance.interceptors.request.use(config => {
        return config;
    })
    instance.interceptors.response.use(res => {
        console.log(res);
        const status = res.status;
        if (status === 200 || status === 301 || status === 302 || status === 303) {
            return res;
        }
    }, err => {
        if (err && err.response && err.response.status) {
            const status = err.response.status;
            if (status === 403) {
                ElMessageBox.alert('您没有权限:如需开通请联系直属上级！', {
                    confirmButtonText: "确定",
                  });
                return false;
            }

        } if (err && err.response && err.response.status && err.response.status == 400) {
            return err.response
        } else {
            ElMessageBox.alert(`专升本网后台管理系统(系统异常)${config.url},请将当前页全部截图然后联系技术人员处理!`, {
                confirmButtonText: "确定",
              });
        }

        return err;
    })

    return instance(config)
}

// 请求实例2：需要token调用此实例
var isRefreshing = false; //是否正在刷新的标志
export function request(config) {
    const instance = axios.create({})
    //  请求拦截器
    instance.interceptors.request.use(config => {
        var authTk = loadUserToken();
        // 日期选择转化
        const moment = require('moment')
        for (const k in config.data) {
            if (config.data[k] && config.data[k] instanceof Date) {
                config.data[k] = moment(config.data[k]).add(8, 'hours').local().toISOString()
            }
        }
        if (authTk) {
            config.headers.Authorization = 'Bearer' + ' ' + authTk;
            var currentUrl = config.url.toLowerCase();
            /*判断token是否将要过期,当前请求不是刷新请求 */
            if (isAccessTokenExpired() && currentUrl.indexOf('refreshToken'.toLowerCase()) == -1) {
                if (!isRefreshing) {
                    isRefreshing = true;
                    getRefreshToken().then(function (res) {
                        var result = res && res.data.result ? res.data.result : '';
                        if (result !== ''&& res.status == 200&&res.data.code==1) {
                            let expiresTime = result.expires_in + new Date() / 1000
                            const tokenObj = {
                                AccessToken: result.access_token,
                                AccessExpiresIn: expiresTime,
                                RefreshToken: result.refresh_token
                            }
                            store.commit('updateToken', tokenObj)
                            //超过24小时删除Token
                            isDayToken()
                            config.headers.Authorization = 'Bearer' + ' ' + result.access_token;
                            onRrefreshed(result.access_token);
                            refreshSubscribers = [];
                        } else {
                            ElMessage({
                                message: '登录超时请重新登陆！',
                                type: 'warning'
                            });
                            setTimeout(() => {
                                logOut();
                            }, 2000)
                        }
                    }).catch(function (err) {
                        logOut();
                        return err;
                    }).finally(() => {
                        isRefreshing = false;
                    })
                    /*把请求(token)=>{....}都push到一个数组中*/
                    var retry = new Promise(function (resolve, reject) {
                        /*(token) => {...}这个函数就是回调函数*/
                        subscribeTokenRefresh(function (token) {
                            config.headers.Authorization = 'Bearer ' + token;
                            /*将请求挂起*/
                            resolve(config)
                        })
                    });
                    return retry
                }
                return config;
            } else {
                return config;
            }
        } else {
            return config;
        }
    }, err => {
        return err
    })
    // 3. 响应拦截器
    instance.interceptors.response.use(res => {
        if (res.status === 200 || res.status === 301 || res.status === 302 || res.status === 303) {
            return res.data;
        }
    }, err => {
        if (err && err.response && err.response.status) {
            const status = err.response.status;
            if (status === 401) {
                    var errConfig = err.config, //失败的请求头
                        accessToken = store.state.token.AccessToken,
                        refreshToken = store.state.token.RefreshToken;
                    if (refreshToken) {
                        if (!isRefreshing) {
                            isRefreshing = true;
                            getRefreshToken().then(function (res) {
                                var result = res && res.data.result ? res.data.result : '';
                                if (result !== ''&& res.status == 200&&res.data.code==1) {
                                    store.commit('updateToken', {
                                        AccessToken: result.access_token,
                                        RefreshToken: result.refresh_token
                                    })
                                    errConfig.headers.Authorization = 'Bearer ' + result.access_token; //覆盖旧accessToken
                                    return instance(errConfig);
                                } else {
                                    logOut();
                                }
                            }).catch(function (err) {
                                logOut(); //跳转登录页
                                return err;
                            }).finally(function () {
                                isRefreshing = false;
                            })
                        }
                    } else {
                        logOut(); //跳转登录页
                    }
            } else if (status === 403) {
                ElMessageBox.alert('您没有权限:如需开通请联系直属上级', {
                    confirmButtonText: "确定",
                  });
                
            } else {
                ElMessageBox.alert(`专升本网后台管理系统(系统异常)${config.url},请将当前页全部截图然后联系技术人员处理!`, {
                    confirmButtonText: "确定",
                  });
            }
        }
        // 接口报403时，不反悔错误信息
        const status = err.response.status;
        if (status != 403) return err;
    })

    // 4. 返回实例
    return instance(config)
}
// 获取AccessToken
function loadUserToken() {
    let token = store.state.token || JSON.parse(sessionStorage.getItem('token'));
    let accessToken = token.AccessToken;
    return accessToken;
}
// 判断AccessToken是否过期
function isAccessTokenExpired() {
    let token = store.state.token || JSON.parse(sessionStorage.getItem('token'));
    let accessToken = token.AccessToken;
    let expires_in = token.AccessExpiresIn;
    if (!accessToken || !expires_in) return false;
    var currentTime = Date.parse(new Date()) / 1000;
    var expiresTime = expires_in;
    // 600秒后即将过期,true则不需要刷新
    return expiresTime - currentTime <= 60
}
// 请求新AccessToken
function getRefreshToken() {
    let token = store.state.token || JSON.parse(sessionStorage.getItem('token'));
    const refreshToken = token.RefreshToken;
    let params = new URLSearchParams();
    params.append('grant_type', grant_type);
    params.append('client_id', client_id);
    params.append('client_secret', client_secret);
    params.append('refresh_token', refreshToken);
    return requestPublic({
        url: '/api1/connect/token',
        method: 'post',
        data: params
    })
}
// 存储token  24小时
function isDayToken() {
    let token = store.state.token || JSON.parse(sessionStorage.getItem('token'));
    let accessToken = token.AccessToken;
    let expires_in = token.AccessExpiresIn;
    if (!accessToken || !expires_in) return false;
    let currentTime = Date.parse(new Date()) / 1000;
    let expiresTime = expires_in;
    // 24小时后删除Token
    if (currentTime - expiresTime > 86400) {
        sessionStorage.removeItem('token')
    }
}
// 存储请求的数组
var refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去请求数据
function onRrefreshed(token) {
    refreshSubscribers.map(function (cb) {
        return cb(token);
    })
}